<span title="{{ tooltipDisplayValue() }}">{{ textDisplayValue() }}</span>
